var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownPagePicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56409 5.64333L9.80159 1.39833C9.87189 1.32861 9.92768 1.24566 9.96576 1.15426C10.0038 1.06287 10.0234 0.964838 10.0234 0.865829C10.0234 0.76682 10.0038 0.668791 9.96576 0.577396C9.92768 0.486002 9.87189 0.403051 9.80159 0.333329C9.66107 0.193641 9.47098 0.115234 9.27284 0.115234C9.0747 0.115234 8.88461 0.19364 8.74409 0.333329L4.99409 4.04583L1.28159 0.333328C1.14107 0.19364 0.950977 0.115234 0.752838 0.115234C0.554699 0.115234 0.364611 0.19364 0.224089 0.333328C0.153222 0.402789 0.0968447 0.485623 0.0582218 0.57703C0.0195999 0.668436 -0.0004988 0.766598 -0.000910792 0.865828C-0.000498809 0.965059 0.0195999 1.06322 0.0582218 1.15463C0.0968446 1.24603 0.153222 1.32887 0.224089 1.39833L4.46159 5.64333C4.53182 5.71946 4.61706 5.78021 4.71193 5.82177C4.80681 5.86332 4.90926 5.88478 5.01284 5.88478C5.11641 5.88478 5.21887 5.86332 5.31374 5.82177C5.40862 5.78021 5.49386 5.71946 5.56409 5.64333Z",
    fill: "#5932EA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownPagePicker);
export default __webpack_public_path__ + "static/media/arrow_down_pagePicker.9d9002b4c52b7069f00542606ec6a7cc.svg";
export { ForwardRef as ReactComponent };